import React from "react";
import { Link } from "react-router-dom";
import Ecofy from "../Assets/Images/logo-ecofy-green.png";
import SavaniLogo from "../Assets/Images/savani.jpg";
import ShivalikLogo from "../Assets/Images/shivalik-logo.jpeg";
import DMILogo from "../Assets/Images/DMILogo.svg";
const Lenders = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        flexDirection: "column",
        padding: "60px",
      }}
    >
      <div style={{ fontSize: "40px", fontWeight: "600" }}>Our Lenders</div>
      <div className="d-flex align-items-center" style={{ gap: "24px" }}>
        {" "}
        <img src={Ecofy} alt="Ecofy" height={"80px"} width={"250px"} />
        <img src={SavaniLogo} alt="Savani" height={"100px"} width={"150px"} />
        <img
          src={ShivalikLogo}
          alt="Shivalik"
          height={"100px"}
          width={"250px"}
        />
        <Link to="/dmi-portfolio">
          <img
            src={DMILogo}
            alt="DMI"
            height={"100px"}
            width={"250px"}
            style={{ cursor: "pointer" }}
          />
        </Link>
      </div>
    </div>
  );
};
export default Lenders;
